
import React from 'react';
import PropTypes from 'prop-types';

import LoadingProgress from 'lib/react-router/loading-progress';
import FetchData from 'lib/fetch-data/fetch-data';
import Localizable from 'lib/intl/localizable';

import ErrorPage from 'four-nets/errors/error-page';
import { CategoryStore } from 'four-nets/forum/forum';
import { UserStore } from 'four-nets/user/user';

import ForumView from './forum-view';

@Localizable()
class ForumLoader extends React.PureComponent {
    static contextTypes = {
        api: PropTypes.object,
        userStore: PropTypes.instanceOf(UserStore),
    };

    transform = data => {
        const { api, userStore } = this.context;
        const { intl } = this.props;

        const categoryStore = new CategoryStore({
            api,
            userStore,
            intl,
        });

        categoryStore.fromJSON({ json: data.categoryStore });

        return {
            categoryStore,
        };
    };

    fetch = setData => {
        const { api, userStore } = this.context;
        const { intl } = this.props;

        const categoryStore = new CategoryStore({
            api,
            userStore,
            intl,
        });

        setData({
            categoryStore,
        });

        return Promise.resolve();
    };

    renderFetch = ({ loading, error, data }) => {
        return (
            <LoadingProgress loading={loading}>
                <ErrorPage error={error}>{data ? <ForumView categoryStore={data.categoryStore} /> : null}</ErrorPage>
            </LoadingProgress>
        );
    };

    render() {
        return (
            <FetchData
                serializerKey={__filename}
                fetch={this.fetch}
                render={this.renderFetch}
                transform={this.transform}
            />
        );
    }
}

export default (ForumLoader);
